import moment from 'moment-timezone';
import store from '../../store/store'

const momentUtcToUserTz = (val, deviceTimeZone) => {
	if (!val) {
		return "";
	}

	const localTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
	const savedTimeZone = store.getState().user.user.settings.time_zone;
	const userTimeZone = (savedTimeZone === 'device' ? deviceTimeZone : savedTimeZone) || localTZ;

	return moment.utc(val).tz(userTimeZone);
};

export default momentUtcToUserTz
